module.exports = function() {
  App.Views = require('view');
  $.extend(App.Views, require('articleMessage'));
  App.Views.IconImageUploadForm = require('user');
  $.extend(App.Views, require('offer'));
};



// WEBPACK FOOTER //
// ./pc/view.js